import './RegionSelector2Input.css';

import React, { useEffect } from 'react';
import { Select, SuggestInput, useSelect } from '@vtblife/uikit';
import classname from '@search/classname/src';
import type { RegionSelector2Item } from './RegionSelector2Item';

const cn = classname.bind(null, 'RegionSelector2Input');

type Awaited<T> = T extends PromiseLike<infer U> ? U : T;

export function RegionSelector2Input({
    children,
    valueInitial = '',
    setSelectedId,
    getVariants
}: {
    valueInitial?: string;
    getVariants(text: string): Promise<RegionSelector2Item[]>;
    setSelectedId(id?: RegionSelector2Item['id']): void;
    children?: React.ReactNode;
}) {
    const [ results, setResults ] = React.useState([] as Awaited<ReturnType<typeof getVariants>>);

    const [ needle, setNeedle ] = React.useState(valueInitial);

    useEffect(() => {
        setNeedle(valueInitial);
    }, [ valueInitial ]);

    const selectId = React.useCallback((id: RegionSelector2Item['id']) => {
        setNeedle('');
        setSelectedId(id);
    }, [ setSelectedId ]);

    const { is, handleChange } = useSelect(selectId);

    const handleSuggestChange = React.useCallback(async (next: Parameters<typeof getVariants>[0]) => {
        const suggested = await getVariants(next);

        setResults(next && suggested.length > 0 ? suggested : []);
        setNeedle(next);
        if (! next) setSelectedId();

        return true;
    }, [ getVariants, setSelectedId ]);

    return (
        <div className={cn()}>
            <Select onChange={handleChange} mode='single'>
                <SuggestInput
                    placeholder='Введите регион или город'
                    onChange={handleSuggestChange}
                    value={needle}
                    debounce={0}
                />
                {needle && needle !== valueInitial && (<Select.Content
                    adaptivePlacement={false}
                >
                    {results.length === 0 && (
                        <Select.Option
                            disabled
                            key='NotFound'
                            value='NotFound'
                        >
                            Ничего не найдено
                        </Select.Option>
                    )}

                    {results.length > 0 &&
                        results.map(item => (
                            <Select.Option key={item.id} value={item.id} selected={is(item.id)}>
                                {item.displayName}
                            </Select.Option>
                        ))}
                </Select.Content>)}
            </Select>
            {children && (
                <div style={{ width: '150px' }}>
                    {children}
                </div>
            )}
        </div>
    );
}
